<template>
  <div>
    <div class="image-preview-wrapper">
      <div class="image-preview">
        <img
          id="imgPrev"
          class="buttonPhoto"
          :src="photoComp"
          crossOrigin="Anonymous"
        />

        <span class="my-button">
          <label class="btn btn-title btn-success">
            Photo <i class="fa fa-camera" />
            <input
              style="display: none"
              class="file"
              type="file"
              @change="previewThumbnail"
              accept="image/jpeg, image/bmp, image/png"
            />
          </label>
        </span>
      </div>
    </div>

    <div class="container">
      <div
        class="modal fade"
        id="cropModalAddMore"
        role="dialog"
        aria-labelledby="modalLabel"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title" id="modalLabel">
                <i class="fa fa-camera"></i> Add Photo
              </h2>
            </div>
            <div class="modal-body row">
              <div
                class="col-md-6"
                style="max-width: 100%; max-height: 300px; overflow: hidden"
              >
                <img
                  id="cropMeAddMore"
                  :src="uploadedImageSrc"
                  alt="Picture"
                  style="max-width: 100%; max-height: 300px"
                  crossorigin
                />
                <div v-if="uploading" class="progress progress-image">
                  <div
                    class="
                      progress-bar progress-bar-success progress-bar-striped
                    "
                    role="progressbar"
                    :style="{ width: uploadCompletePct }"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <span> {{ uploadStatusPct }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 hidden-xs hidden-sm">
                <div class="docs-preview clearfix">
                  <div class="img-preview preview-md"></div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                @click="saveImage"
                class="btn btn-title btn-success"
              >
                Save Image
              </button>
              <button
                type="button"
                @click="cancelSave"
                class="btn btn-title btn-default"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import auth from "../../../auth";
import store from "../../../data/store";
import loadImage from "blueimp-load-image";

export default {
  name: "UploadAddMore",
  data() {
    return {
      filePath: "",
      cropOptions: {
        aspectRatio: 5 / 5,
        background: false,
        autoCropArea: 0.8,
        checkCrossOrigin: true,
        modal: true,
        preview: ".img-preview",
        checkOrientation: false,
      },
      cropNames: {
        cropMe: "cropMeAddMore",
        modal: "cropModalAddMore",
      },
      uploadCompletePct: "",
      uploading: false,
      profilePhoto: {
        Path: "",
        SitterPhotoId: 0,
        Type: "",
      },
      uploadedImageSrc: "",
    };
  },
  methods: {
    previewThumbnail: function (event) {
      var orientationVal = true;
      var input = event.target;
      if (input.files && input.files[0]) {
        var self = this;
        self.uploadCompletePct = "";
        var file = input.files[0];

        loadImage.parseMetaData(file, function (data) {
          // Get the correct orientation setting from the EXIF Data
          if (data.exif) {
            orientationVal = data.exif.get("Orientation");
          } else orientationVal = true;

          var loadingImage = loadImage(file);

          loadingImage.onload = function (e) {
            var scaledImage = loadImage.scale(
              loadingImage, // img or canvas element
              { orientation: orientationVal }
            );

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            var maxWidth = 800,
              maxHeight = 800,
              imageWidth = scaledImage.width,
              imageHeight = scaledImage.height;

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
              }
            }
            canvas.width = imageWidth;
            canvas.height = imageHeight;

            ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);

            // The resized file ready for upload
            var finalFile = canvas.toDataURL("image/png");

            $("#" + self.cropNames.modal).modal("show");
            self.uploadedImageSrc = finalFile;
          };
        });
      }
    },
    cancelSave: function () {},
    saveImage: function () {
      var self = this;
      self.uploading = true;
      self.uploadCompletePct = "";
      $("#" + self.cropNames.cropMe)
        .cropper("getCroppedCanvas")
        .toBlob(
          function (blob) {
            var formData = new FormData();
            formData.append("image", blob);

            $.ajax(
              "https://www.dupaws.com/services/api/postSitterProfilePhoto/" + 1,
              {
                //1 = typeId is profilePhoto
                type: "POST",
                data: formData,
                xhr: function () {
                  // custom xhr
                  var xhr = new window.XMLHttpRequest();
                  xhr.upload.addEventListener(
                    "progress",
                    function (evt) {
                      if (evt.lengthComputable) {
                        var percentComplete = evt.loaded / evt.total;
                        self.uploadCompletePct =
                          Math.round(percentComplete * 100) + "%";
                      }
                    },
                    false
                  );
                  return xhr;
                },
                beforeSend: function (xhr) {
                  xhr.setRequestHeader(
                    "Authorization",
                    "bearer " + localStorage.getItem("access_token")
                  );
                },

                cache: false,
                crossDomain: true,
                processData: false,
                contentType: false,
                success: function (data) {
                  store.getters.SitterPhotos.push(data);
                  self.uploading = false;
                  self.uploadCompletePct = "";
                  $("#" + self.cropNames.modal).modal("hide");
                  self.$parent.$parent.updateProfileStatus();
                },
                error: function () {
                  self.uploadCompletePct = "";
                  self.uploading = false;
                },
              }
            );
          },
          "image/jpeg",
          0.85
        );
    },
  },
  mounted: function () {
    var self = this;

    $("#" + self.cropNames.modal)
      .on("shown.bs.modal", function () {
        $("#" + self.cropNames.cropMe).cropper(self.cropOptions);
      })
      .on("hidden.bs.modal", function () {
        $("#" + self.cropNames.cropMe).cropper("destroy");
      });
  },
  computed: {
    uploadStatusPct: function () {
      var self = this;
      return "Uploading image " + self.uploadCompletePct + " complete.";
    },
    photoComp: function () {
      return "https://www.dupaws.com/services/images/site/addMore.jpg";
    },
  },
};
</script>
<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.buttonPhoto {
  width: 100%;
  height: 100%;
}

.image-preview-wrapper {
  height: 100px;
  width: 100px;
}

.image-preview {
  position: absolute;
  border: 1px;
  border-style: solid;
  border-color: #e3e3e3;
  width: 100px;
  border-radius: 5px;
  height: 100px;
  text-align: center;
}

.my-button {
  position: relative;
  bottom: 50px;
}

.progress span {
  position: absolute;
  display: block;
  width: 100%;
  color: #3c3b3b;
}

.progress-image {
  position: absolute;

  width: 80%;
  z-index: 500;
  opacity: 0.9;

  top: 50%;
  left: 10%;
}

.img-preview {
  background-color: #f7f7f7;
  width: 200px;
  height: 200px;
  text-align: center;
}

.img-preview {
  float: left;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  border-radius: 5px;
}

.image-preview .close {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 100;
  background-color: #fff;
  padding: 3px 2px 2px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  opacity: 0.2;
  text-align: center;
  font-size: 22px;
  line-height: 10px;
  border-radius: 50%;
}

.my-button:hover {
  opacity: 1;
}

.image-preview:hover .close {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// UploadAddMore.vue?7607a043